//
export const BRAND_NAME = "Dịch Vụ Chuyển Âm"; // Brand Name
export const MASTER_EMAIL = "leminhnghia.master@vivn.vn";
export const SANDBOX = false;

// =========================  String ========================= //
export const SOURCE = "vivietnam";
export const VERSION = "v0.1.0";
export const WEB_DOMAIN = "https://dichvuchuyenam.com/";
export const DATABASE_URL =
  "https://vi-viet-nam-user-default-rtdb.asia-southeast1.firebasedatabase.app";
export const TINY_MCE_API_KEY =
  "cp07nd8dz1s0v5lkqakv4ipqz1h3emg6clogvw87edmiutf1";

// export const MAP_API = "AIzaSyBEcXTuXbCurxD5uCX4moSZ5jlTRMI0lyY";

export const ALGOLIA = {
  APP: "",
  API: "",
  INDEX: "",
};
